import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden !important;
  background-image: linear-gradient(180deg, #663399, #07040b);
  display: flex;
  flex-direction: column;
  padding: 0 4rem;
  justify-content: center;
  align-items: center;
  position: relative;

  .logoUx {
    width: 133.71px;
    margin: 0 auto;
    margin-bottom: 1.5rem;
    z-index: 10;
  }

  .computerUx {
    width: 266.6px;
    margin: 0 auto;
    margin-bottom: 4.2rem;
    margin-top: 1rem;
    z-index: 20;
  }
`;

export const Description = styled.span`
  font-size: 2.2rem;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  color: white;
  line-height: 150%;
  text-align: center;
  margin: 0 auto;
  max-width: 400px;
  z-index: 10;
`;

export const DecorationWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  z-index: 1;
  flex-direction: column;
`;

export const ContentMobile = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;
